/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementCTCustomErrorResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchAcceptanceResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * This Api is to validate the expected pouch from same or different branches as it also supports cross branch functionality i.e, user can get the expected pouches from other branches as well. This will be used in Pouch acceptance process.
 * @summary Validate expected pouch ID
 */
export const getAcceptanceValidate = (pouchID: string, signal?: AbortSignal) => {
  return customInstance<GetPouchAcceptanceResponseResponse>({
    url: `/bm-pouch-management/v1/acceptance/validate/${pouchID}`,
    method: 'get',
    signal,
  });
};

export const getGetAcceptanceValidateQueryKey = (pouchID: string) => {
  return [`/bm-pouch-management/v1/acceptance/validate/${pouchID}`] as const;
};

export const getGetAcceptanceValidateQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcceptanceValidate>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementCTCustomErrorResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAcceptanceValidate>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAcceptanceValidateQueryKey(pouchID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAcceptanceValidate>>> = ({ signal }) =>
    getAcceptanceValidate(pouchID, signal);

  return { queryKey, queryFn, enabled: !!pouchID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcceptanceValidate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcceptanceValidateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcceptanceValidate>>
>;
export type GetAcceptanceValidateQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementCTCustomErrorResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Validate expected pouch ID
 */
export const useGetAcceptanceValidate = <
  TData = Awaited<ReturnType<typeof getAcceptanceValidate>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementCTCustomErrorResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAcceptanceValidate>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAcceptanceValidateQueryOptions(pouchID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
